import React from 'react';
import { ControllerBaseLayout } from 'router/ControllerBaseLayout';
import { Race } from 'pages/Race';
import { SendAffiliate } from 'pages/Race/SendAffiliateRequest';
import { RaceRef } from 'pages/Race/RaceRef';
import { SendLeaderRequest } from 'pages/Race/SendLeaderRequest';

export const raceRoutesBase = {
  path: 'race',
  children: [
    {
      path: 'ref/:userRef',
      element: (
        <ControllerBaseLayout bg="primary" isHaveButtonBack>
          <RaceRef />
        </ControllerBaseLayout>
      ),
    },
    {
      index: true,
      element: (
        <ControllerBaseLayout bg="secondary" isHaveButtonBack>
          <Race />
        </ControllerBaseLayout>
      ),
    },
  ],
};

export const raceRoutesAuth = {
  path: 'race',
  children: [
    {
      path: 'affiliate-send',
      element: <SendAffiliate />,
    },
    {
      path: 'leader-send',
      element: <SendLeaderRequest />,
    },
  ],
};
